var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"商品日志","visible":_vm.dialogVisible,"width":"90%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('ProdLog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }